/**
 * computeProgressSegments
 *
 * Given a list of rule groups and a total limit, compute normalized width
 * percentages for each segment in the progress bar.
 *
 * @param ruleGroups List of groups containing at least { ruleId, totalRequested }
 * @param totalLimit The total limit across all groups
 * @returns { segments, totalWidth }
 */
export default function computeProgressSegments(ruleGroups, totalLimit) {
    if (!ruleGroups.length || totalLimit <= 0) {
        return { segments: [], totalWidth: 0 };
    }
    let currentLeftPercent = 0;
    const segments = [];
    for (const group of ruleGroups) {
        const requestedAmount = Math.max(0, Number(group.totalRequested || 0));
        const rawWidthPercent = (requestedAmount / totalLimit) * 100;
        const clampedWidthPercent = Math.max(0, Math.min(rawWidthPercent, 100 - currentLeftPercent));
        if (clampedWidthPercent <= 0)
            continue;
        segments.push({ left: currentLeftPercent, width: clampedWidthPercent, key: group.ruleId });
        currentLeftPercent = Math.min(100, currentLeftPercent + clampedWidthPercent);
        if (currentLeftPercent >= 100)
            break;
    }
    return { segments, totalWidth: currentLeftPercent };
}
